import { useMutation, useQueryClient } from '@tanstack/react-query'
import { ExtendableMutationOptions } from 'shared/api/api.types'
import { authApi } from 'shared/api/auth'

import { onLoginSuccess } from '../../utils/onLoginSuccess'
import { OauthLoginRequest, OauthLoginResponse } from './oauthLogin.types'

export const oauthLogin = async (request: OauthLoginRequest) => {
  const response = await authApi.post<OauthLoginResponse>(
    'oauth/login',
    request
  )
  return response.data
}

export const useOauthLoginMutation = (
  options?: ExtendableMutationOptions<OauthLoginResponse, OauthLoginRequest>
) => {
  const queryClient = useQueryClient()

  return useMutation({
    mutationFn: req => {
      return oauthLogin(req)
    },
    ...options,
    onSuccess: (data, ...args) => {
      onLoginSuccess(data.data, queryClient, true)
      options?.onSuccess?.(data, ...args)
    }
  })
}
